import React, { useRef, useState, useEffect } from "react";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import InputComponent from "../TestScheduling/Input-testscheduling";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import introgativeImgBlue from "../../../Assets/Images/CommanImages/IntrogativeBlue.png";
import TextEditor from "../DppScheduling/TextEditor";
import InputComponent2 from "../DppScheduling/InputComponent";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import SucessImg from "../../../Assets/Images/CommanImages/success.png";
import MultiSelectSearchDropdown from "../DppScheduling/MultiDropdownClassic";
import { useLocation } from "react-router-dom";
import { POST } from "../../../Api/HttpsMethods";
import { GET } from "../../../Api/HttpsMethods";
import EndPoints from "../../../Api/EndPoints";
import { useNavigate } from "react-router-dom";
import Colors from "../../../Constants/Colors";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";

const DPPSchedulingNotification = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
}) => {
  const location = useLocation();
  const dppData = location.state;
  const navigate = useNavigate();

  useEffect(() => {
    if (dataClient) {
      const userName =
        dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
      const clientBranchId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
      const clientId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
      sessionStorage.setItem("user_name", userName);
      sessionStorage.setItem("clientBranchId", clientBranchId);
      sessionStorage.setItem("clientId", clientId);
    }
  }, [dataClient]);

  const userName =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
    sessionStorage.getItem("user_name") ||
    "";
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
    sessionStorage.getItem("clientBranchId") ||
    null;
  const clientId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
    sessionStorage.getItem("clientId") ||
    null;
  const accessToken = localStorage.getItem("other");
  const [selectedQuestionPaperSubjects, setSelectedQuestionPaperSubjects] =
    useState("");
  const [selectedChapterId, setSelectedChapterId] = useState([]); // was ""
  const [selectedChapterName, setSelectedChapterName] = useState("");
  const [selectedTopicId, setSelectedTopicId] = useState([]); // was ""
  const [selectedTopicName, setSelectedTopicName] = useState("");
  const [instructionsHtml, setInstructionsHtml] = useState("");
  const [selectedQuestionPaperId, setSelectedQuestionPaperId] = useState("");
  const [selectedQuestionPaperName, setSelectedQuestionPaperName] =
    useState("");
  const [
    selectedQuestionPaperDescription,
    setSelectedQuestionPaperDescription,
  ] = useState("");
  const [selectedQuestionPaperCreatedBy, setSelectedQuestionPaperCreatedBy] =
    useState("");
  const [testTemplates, setTestTemplates] = useState([]);
  const [testStartDate, setTestStartDate] = useState(null);
  const [testEndDate, setTestEndDate] = useState(null);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [classes, setClasses] = useState([]); // New state for classes
  const [topics, setTopics] = useState([]);
  const [questionPapers, setQuestionPapers] = useState([]);
  const [dppName, setDppName] = useState("");
  const [DppDescription, setDppDescription] = useState("");
  const [CordinatorName, setCordinatorName] = useState("");
  const [batches, setBatches] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [selectedBatchName, setSelectedBatchName] = useState("");
  const [selectedSubjectId, setSelectedSubjectId] = useState("");
  const [selectedSubjectName, setSelectedSubjectName] = useState("");
  const [selectedClassId, setSelectedClassId] = useState("");
  const [selectedClassName, setSelectedClassName] = useState("");

  // FOR STUDENT GROUP
  const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
  const [studentGroupsOptions, setStudentGroupsOptions] = useState([]);
  const [allStudentGroups, setAllStudentGroups] = useState([]);
  const [studentGroupsError, setStudentGroupsError] = useState(null);

  const screenArray = dataClient?.client_schema_name?.[2] || [];
  const scheduleDPPScreen = screenArray.find(
    (screen) =>
      screen.LVL1 === "Question Paper" &&
      screen.LVL2 === "DPP" &&
      screen.LVL3 === "Schedule DPP"
  );
  const screenId = scheduleDPPScreen?.screen_id || 0;

  useEffect(() => {
    if (!userName || !clientBranchId) return; // wait until values are available

    const fetchTestTemplates = async () => {
      try {
        const token = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-dpp-instructions-template-list/?username=${userName}&branch_id=${clientBranchId}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setTestTemplates(data);
      } catch (error) {
        console.error("Error fetching test templates:", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching test templates: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };
    fetchTestTemplates();
  }, [userName, clientBranchId]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`, {
          headers: { accept: "application/json" },
        });
        const data = await response.json();
        setCourses(data);
      } catch (error) {
        console.error("Error fetching courses:", error);
        if (setMessageBox) {
          setMessageBox("Error fetching courses: " + error.message);
          setIsMessageBoxVisible(true);
          setActiveImg("error");
        }
      }
    };
    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchBatches = async () => {
      if (!selectedCourseId) return;
      const url = `${EndPoints.GetBatchByCourse}?course_id=${selectedCourseId}`;
      const data = await GET.noToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
      // Filter batches by selectedClassId if set
      if (Array.isArray(data?.[0])) {
        if (selectedClassId) {
          setBatches(
            data[0].filter((batch) => batch.class_id === selectedClassId)
          );
        } else {
          setBatches(data[0]);
        }
      } else {
        setBatches([]);
      }
    };
    fetchBatches();
  }, [selectedCourseId, selectedClassId]);

  useEffect(() => {
    const fetchSubjects = async () => {
      if (!selectedCourseId) return;
      const url = `${EndPoints.GetSubjectsByCourse}?course_id=${selectedCourseId}`;
      const data = await GET.noToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
      if (data) setSubjects(data);
    };
    fetchSubjects();
  }, [selectedCourseId]);

  useEffect(() => {
    const fetchChapters = async () => {
      if (!selectedSubjectId) return;
      const url = `${EndPoints.GetChaptersBySubject}?subject_id=${selectedSubjectId}`;
      const data = await GET.noToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
      if (data) setChapters(data);
    };
    fetchChapters();
  }, [selectedSubjectId]);

  useEffect(() => {
    const fetchTopics = async () => {
      if (
        !selectedChapterId ||
        !Array.isArray(selectedChapterId) ||
        selectedChapterId.length === 0
      ) {
        setTopics([]);
        return;
      }
      const data = await POST.withToken(
        EndPoints.TopicsByChapterList,
        selectedChapterId,
        { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
      );
      if (data && data.status_code === 200 && Array.isArray(data.data)) {
        setTopics(data.data);
      } else {
        setTopics([]);
      }
    };
    fetchTopics();
  }, [selectedChapterId]);

  useEffect(() => {
    const fetchClasses = async () => {
      const data = await GET.noToken(EndPoints.GetClasses, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
      if (data) setClasses(data);
    };
    fetchClasses();
  }, []);

  useEffect(() => {
    const fetchQuestionPapers = async () => {
      if (!clientBranchId || !selectedClassId || !selectedSubjectId) {
        return;
      }

      let baseUrl = `${EndPoints.DPP_QUESTION_PAPER_V2}?branch_id=${clientBranchId}&class_id=${selectedClassId}&subject_id=${selectedSubjectId}`;

      if (selectedBatchId) {
        baseUrl += `&batch_id=${selectedBatchId}`;
      }

      if (selectedStudentGroup && selectedStudentGroup.length > 0) {
        const studentGroupIds = Array.isArray(selectedStudentGroup)
          ? selectedStudentGroup
          : [selectedStudentGroup];

        studentGroupIds.forEach((id) => {
          baseUrl += `&student_group_ids=${id}`;
        });
      }

      if (Array.isArray(selectedChapterId) && selectedChapterId.length > 0) {
        selectedChapterId.forEach((id) => {
          baseUrl += `&chapter_id=${id}`;
        });
      }

      if (Array.isArray(selectedTopicId) && selectedTopicId.length > 0) {
        selectedTopicId.forEach((id) => {
          baseUrl += `&topic_id=${id}`;
        });
      }

      try {
        const response = await fetch(baseUrl, {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        const result = await response.json();

        if (result?.status === 200) {
          setQuestionPapers(result.data);
        } else {
          setQuestionPapers([]);
        }
      } catch (error) {
        console.error("Error fetching question papers:", error);
        setQuestionPapers([]);
      }
    };

    fetchQuestionPapers();
  }, [
    selectedChapterId,
    selectedTopicId,
    selectedSubjectId,
    selectedClassId,
    clientBranchId,
    selectedBatchId,
    selectedStudentGroup,
  ]);

  //   const handleSave = async () => {
  //     // Basic validation for required fields
  //     if (
  //       !dppName.trim() ||
  //       !testStartDate ||
  //       !testEndDate
  //     ) {
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>
  //               Please fill in all required fields: DPP Name, Start Date,End Date
  //               and Instructions.
  //             </span>
  //           </div>
  //         </div>
  //       );
  //       setIsMessageBoxVisible(true);
  //       setActiveImg(ErrorImg);
  //       return; // stop further execution
  //     }

  //     const payload = {
  //       ques_paper_id: selectedQuestionPaperId,
  //       dpp_name: dppName,
  //       dpp_desc: DppDescription,
  //       batch_id: selectedBatchId,
  //       student_group_ids: Array.isArray(selectedStudentGroup)
  //         ? selectedStudentGroup : (selectedStudentGroup ? [selectedStudentGroup] : []),
  //       dpp_window_start: testStartDate,
  //       dpp_window_end: testEndDate,
  //       client_id: clientId,
  //       client_branch_id: clientBranchId,
  //       created_by: userName,
  //       instructions_html: instructionsHtml,
  //       subject_id: selectedSubjectId,
  //       chapter_names: selectedChapterName,
  //       topic_names: selectedTopicName,
  //     };

  //     const data = await POST.withToken(EndPoints.CreateDppSchedule, payload, {
  //       setMessageBox,
  //       setIsMessageBoxVisible,
  //       setActiveImg,
  //       ErrorImg,
  //     });

  //     if (data && data.status === 200) {
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>{data.message || "DPP schedule created successfully!"}</span>
  //           </div>
  //         </div>
  //       );
  //       setIsMessageBoxVisible(true);
  //       setActiveImg(SucessImg);

  //       setTimeout(() => {
  //         navigate(-1);
  //       }, 1000);
  //     } else if (data) {
  //       setMessageBox(
  //         <div className="Container-messageBOX">
  //           <div className="messagebox-insider1">
  //             <div className="loader-tc"></div>
  //             <span>
  //               {"Failed to create DPP Schedule: " + data.message || data.detail}
  //             </span>
  //           </div>
  //         </div>
  //       );
  //       setIsMessageBoxVisible(true);
  //       setActiveImg(ErrorImg);
  //     }
  //   };

  const handleSave = async () => {
    if (!dppName.trim() || !testStartDate || !testEndDate) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              Please fill in all required fields: DPP Name, Start Date, End Date
              and Instructions.
            </span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return; // stop further execution
    }

    const payload = {
      request: {
        ques_paper_id: selectedQuestionPaperId,
        dpp_name: dppName,
        dpp_desc: DppDescription,
        batch_id: selectedBatchId,
        student_group_ids: Array.isArray(selectedStudentGroup)
          ? selectedStudentGroup
          : selectedStudentGroup
          ? [selectedStudentGroup]
          : [],
        dpp_window_start: testStartDate,
        dpp_window_end: testEndDate,
        client_id: clientId,
        client_branch_id: clientBranchId,
        created_by: userName,
        instructions_html: instructionsHtml,
        subject_id: selectedSubjectId,
        chapter_names: selectedChapterName,
        topic_names: selectedTopicName,
      },
      payload: {
        user_name: userName,
        client_branch_id: clientBranchId,
        screen_event_id: 4,
        screen_id: 77,
        student_id: 0,
        batch_id: selectedBatchId ? [selectedBatchId] : [],
        subject_id: selectedSubjectId ? [selectedSubjectId] : [],
        class_id: selectedClassId ? [selectedClassId] : [],
        course_id: selectedCourseId ? [selectedCourseId] : [],
        session_id: [],
        student_group_id: Array.isArray(selectedStudentGroup)
          ? selectedStudentGroup
          : selectedStudentGroup
          ? [selectedStudentGroup]
          : [],
      },
    };

    const data = await POST.withToken(
      EndPoints.CREATE_DPP_SCHEDULE_NOTIFICATION,
      payload,
      {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      }
    );

    if (data && data.status === 200) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{data.message || "DPP schedule created successfully!"}</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(SucessImg);

      setTimeout(() => {
        navigate(-1);
      }, 1000);
    } else if (data) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              {"Failed to create DPP Schedule: " + data.message || data.detail}
            </span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
    }
  };

  const getMinEndDate = () => {
    if (!testStartDate) return "";
    const startDate = new Date(testStartDate);
    startDate.setHours(startDate.getHours() + 24);
    // Format the date as "YYYY-MM-DDTHH:MM" for datetime-local input
    return startDate.toISOString().slice(0, 16);
  };

  // Add these helper functions after your state declarations (around line 150)
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const getMinEndDateTime = (startDateTime) => {
    if (!startDateTime) return getCurrentDateTime();

    const startDate = new Date(startDateTime);
    const minEndDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000); // Add 24 hours

    const year = minEndDate.getFullYear();
    const month = String(minEndDate.getMonth() + 1).padStart(2, "0");
    const day = String(minEndDate.getDate()).padStart(2, "0");
    const hours = String(minEndDate.getHours()).padStart(2, "0");
    const minutes = String(minEndDate.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  useEffect(() => {
    if (!selectedQuestionPaperId) {
      setSelectedQuestionPaperSubjects("");
      return;
    }
    const qp = questionPapers.find(
      (q) => q.ques_paper_id === selectedQuestionPaperId
    );
    setSelectedQuestionPaperSubjects(qp?.subject_name || "");
  }, [selectedQuestionPaperId, questionPapers]);

  // CASCADING CLEAR LOGIC USEEFFECTS

  // 1. When class changes, clear batch
  useEffect(() => {
    setSelectedBatchId("");
    setSelectedBatchName("");
  }, [selectedClassId]);

  // 2. When batch changes, clear subject
  useEffect(() => {
    setSelectedSubjectId("");
    setSelectedSubjectName("");
  }, [selectedBatchId]);

  // 3. When subject changes, clear chapter
  useEffect(() => {
    setSelectedChapterId([]);
    setSelectedChapterName("");
  }, [selectedSubjectId]);

  // 4. When chapter changes, clear topic
  useEffect(() => {
    setSelectedTopicId([]);
    setSelectedTopicName("");
  }, [selectedChapterId]);

  // 5. When any of the previous fields from Course to Topic changes, clear Question Paper
  useEffect(() => {
    setSelectedQuestionPaperId("");
    setSelectedQuestionPaperName("");
  }, [
    selectedCourseId,
    selectedClassId,
    selectedBatchId,
    selectedSubjectId,
    selectedChapterId,
    selectedTopicId,
  ]);

  // 6. When Question Paper clears, clear Question Paper Description, Created By, Subjects, and Batch Coordinator Name
  useEffect(() => {
    if (!selectedQuestionPaperId) {
      setSelectedQuestionPaperDescription("");
      setSelectedQuestionPaperCreatedBy("");
      setSelectedQuestionPaperSubjects("");
      setCordinatorName("");
    }
  }, [selectedQuestionPaperId]);

  // Fetch student groups
  useEffect(() => {
    const fetchStudentGroups = async () => {
      if (!clientBranchId) return;

      try {
        setStudentGroupsError(null);

        const url = `${FULL_API_BASE_URL}/get-shared-student-groups?client_branch_id=${clientBranchId}`;

        const resp = await fetch(url, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });

        if (resp.status === 401 || resp.status === 403) {
          setStudentGroupsError("Not authenticated. Please login.");
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
          return;
        }

        const json = await resp.json();

        if (
          json &&
          (json.status === "200" || json.status === 200) &&
          Array.isArray(json.data)
        ) {
          const options = json.data.map((group) => ({
            id: group.student_group_id,
            label: group.student_group_name,
            session_id: group.session_id || "",
            course_id: group.course_id || "",
          }));
          setStudentGroupsOptions(options);
          setAllStudentGroups(options);
        } else {
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
        }
      } catch (err) {
        setStudentGroupsError(err.message || "Error loading student groups");
        setStudentGroupsOptions([]);
        setAllStudentGroups([]);
      }
    };

    fetchStudentGroups();
  }, [clientBranchId, accessToken]);

  // Clear selected student groups when course changes
  useEffect(() => {
    setSelectedStudentGroup([]);
  }, [selectedCourseId]);

  // Get filtered student groups based on selected course
  const getFilteredStudentGroups = () => {
    if (!selectedCourseId) return studentGroupsOptions;
    return studentGroupsOptions.filter((g) => g.course_id === selectedCourseId);
  };

  // Search functionality with course filter
  const searchStudentGroups = (searchKey) => {
    let filtered = allStudentGroups;

    if (selectedCourseId) {
      filtered = filtered.filter((g) => g.course_id === selectedCourseId);
    }

    if (searchKey && searchKey.trim() !== "") {
      filtered = filtered.filter((g) =>
        g.label.toLowerCase().includes(searchKey.toLowerCase())
      );
    }

    setStudentGroupsOptions(filtered);
  };

  const [isOpenSubject, setIsOpenSubject] = useState(true);

  const toggleAccordionSubjects = () => {
    setIsOpenSubject(!isOpenSubject);
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">DPP Scheduling</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={() => navigate(-1)}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSave}>
            SAVE
          </button>
        </div>
      </div>
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>QUESTION PAPER DETAIL</label>
          </div>
        </div>
        <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div>
                <DropDown
                  label="Select Course"
                  style={{ width: "100%" }}
                  setSelected={(selectedId) => {
                    setSelectedCourseId(selectedId);
                    setSelectedCourseName(selectedId.label);
                  }}
                  options={courses.map((course) => ({
                    label: course.course_name,
                    id: course.course_id,
                  }))}
                  isRequired={true}
                />
              </div>
              <div>
                <DropDown
                  key={`class-${selectedCourseId}`}
                  label="Select Class"
                  style={{ width: "100%" }}
                  value={selectedClassId}
                  setSelected={(selectedClassIdFromDD) => {
                    const classOption = Array.isArray(classes)
                      ? classes.find(
                          (cls) => cls.class_id === selectedClassIdFromDD
                        )
                      : undefined;
                    if (classOption) {
                      setSelectedClassId(classOption.class_id);
                      setSelectedClassName(classOption.class_name);
                    } else {
                      setSelectedClassId("");
                      setSelectedClassName("");
                    }
                  }}
                  options={classes.map((cls) => ({
                    label: cls.class_name,
                    id: cls.class_id,
                  }))}
                  isRequired={true}
                />
              </div>
              <div>
                <DropDown
                  key={`batch-${selectedClassId}`}
                  label="Batch Name"
                  style={{ width: "100%" }}
                  value={selectedBatchId}
                  setSelected={(selectedBatchIdFromDD) => {
                    const batchOption = Array.isArray(batches)
                      ? batches.find(
                          (batch) => batch.batch_id === selectedBatchIdFromDD
                        )
                      : undefined;
                    if (batchOption) {
                      setSelectedBatchId(batchOption.batch_id);
                      setSelectedBatchName(batchOption.batch_name);
                    } else {
                      setSelectedBatchId("");
                      setSelectedBatchName("");
                    }
                  }}
                  options={batches.map((batch) => ({
                    label: batch.batch_name,
                    id: batch.batch_id,
                  }))}
                  isRequired={false}
                />
              </div>
              <div>
                <MultiSelectSearchDropdown
                  label="Student Group"
                  width="100%"
                  selected={selectedStudentGroup}
                  setSelected={setSelectedStudentGroup}
                  options={getFilteredStudentGroups().map((g) => ({
                    label: g.label,
                    id: g.id,
                  }))}
                  isRequired={false}
                  placeholder="Select Student Group..."
                  singleSelect={false}
                  onSearchInputChange={searchStudentGroups}
                />
                {studentGroupsError && (
                  <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                    {studentGroupsError}
                  </div>
                )}
              </div>
              <div>
                <DropDown
                  key={`subject-${selectedBatchId}`}
                  label="Select Subject"
                  style={{ width: "100%" }}
                  value={selectedSubjectId}
                  setSelected={(selectedSubjectIdFromDD) => {
                    console.log(
                      "Subject id selected:",
                      selectedSubjectIdFromDD
                    );
                    const subjectOption = Array.isArray(subjects)
                      ? subjects.find(
                          (subject) =>
                            subject.subject_id === selectedSubjectIdFromDD
                        )
                      : undefined;
                    if (subjectOption) {
                      setSelectedSubjectId(subjectOption.subject_id);
                      setSelectedSubjectName(subjectOption.subject_name);
                    } else {
                      setSelectedSubjectId("");
                      setSelectedSubjectName("");
                    }
                  }}
                  options={subjects.map((subject) => ({
                    label: subject.subject_name,
                    id: subject.subject_id,
                  }))}
                />
              </div>
              <div>
                <MultiSelectSearchDropdown
                  label="Select Chapter (Optional)"
                  width="100%"
                  selected={selectedChapterId}
                  setSelected={(selectedIds) => {
                    setSelectedChapterId(selectedIds);
                    if (Array.isArray(selectedIds) && selectedIds.length > 0) {
                      const selectedChapters = chapters.filter((chapter) =>
                        selectedIds.includes(chapter.chapter_id)
                      );
                      const names = selectedChapters
                        .map((chapter) => chapter.chapter_name)
                        .join(", ");
                      setSelectedChapterName(names);
                    } else {
                      setSelectedChapterName("");
                    }
                  }}
                  options={chapters.map((chapter) => ({
                    label: chapter.chapter_name,
                    id: chapter.chapter_id,
                  }))}
                  isRequired={false}
                />
              </div>
              <div>
                <MultiSelectSearchDropdown
                  label="Select Topic(Optional)"
                  width="100%"
                  selected={selectedTopicId}
                  setSelected={(selectedIds) => {
                    setSelectedTopicId(selectedIds);
                    if (Array.isArray(selectedIds) && selectedIds.length > 0) {
                      const selectedTopics = Array.isArray(topics)
                        ? topics.filter((topic) =>
                            selectedIds.includes(topic.topic_id)
                          )
                        : [];
                      const names = selectedTopics
                        .map((topic) => topic.topic_name)
                        .join(", ");
                      setSelectedTopicName(names);
                    } else {
                      setSelectedTopicName("");
                    }
                  }}
                  options={
                    Array.isArray(topics)
                      ? topics.map((topic) => ({
                          label: topic.topic_name,
                          id: topic.topic_id,
                        }))
                      : []
                  }
                  isRequired={false}
                />
              </div>
              <div>
                <DropDown
                  label="Question Paper Name"
                  style={{ width: "100%" }}
                  setSelected={(selectedQPId) => {
                    const qpOption = Array.isArray(questionPapers)
                      ? questionPapers.find(
                          (qp) => qp.ques_paper_id === selectedQPId
                        )
                      : undefined;
                    if (qpOption) {
                      setSelectedQuestionPaperId(qpOption.ques_paper_id);
                      setSelectedQuestionPaperName(qpOption.ques_paper_name);
                      setSelectedQuestionPaperDescription(qpOption.description);
                      setSelectedQuestionPaperCreatedBy(qpOption.created_by);
                      setSelectedQuestionPaperSubjects(
                        qpOption.subject_name || ""
                      );
                    } else {
                      setSelectedQuestionPaperId("");
                      setSelectedQuestionPaperName("");
                      setSelectedQuestionPaperDescription("");
                      setSelectedQuestionPaperCreatedBy("");
                      setSelectedQuestionPaperSubjects("");
                    }
                  }}
                  options={questionPapers.map((qp) => ({
                    label: qp.ques_paper_name,
                    id: qp.ques_paper_id,
                  }))}
                  isRequired={true}
                  minheight="250px"
                  Height="auto"
                  OverFlow="auto"
                />
              </div>
              <div>
                <InputComponent
                  label="Question Paper Subjects"
                  style={{ width: "100%" }}
                  value={selectedQuestionPaperSubjects}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <InputComponent
                  label="Question Paper Created By"
                  style={{ width: "100%" }}
                  value={selectedQuestionPaperCreatedBy}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div style={{ gridColumn: "2 / 4" }}>
                <InputComponent
                  label="Question Paper Description"
                  style={{ width: "100%" }}
                  value={selectedQuestionPaperDescription}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <FormInputs
                  label="DPP Name"
                  value={dppName}
                  onChange={(e) => setDppName(e.target.value)}
                  placeholder="Enter DPP name"
                  style={{ width: "100%" }}
                  required
                />
              </div>

              <div style={{ gridColumn: "2 / 4" }}>
                <FormInputs
                  label="Description"
                  value={DppDescription}
                  onChange={(e) => setDppDescription(e.target.value)}
                  placeholder="Enter Description"
                  style={{ width: "100%" }}
                  required
                />
              </div>
              <div>
                <FormInputs
                  label="Batch Coordinator Name"
                  style={{ width: "100%" }}
                  value={CordinatorName}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <FormInputs
                  label="DPP Window Start"
                  style={{ width: "100%" }}
                  value={testStartDate || ""}
                  isRequired={false}
                  disable={false} // Keep editable for datetime selection
                  type="datetime-local" // Add type prop if FormInputs supports it
                  min={getCurrentDateTime()}
                  onChange={(e) => {
                    const newStartDate = e.target.value;
                    setTestStartDate(newStartDate);
                    if (testEndDate) {
                      const minEndTime = getMinEndDateTime(newStartDate);
                      if (testEndDate < minEndTime) {
                        setTestEndDate("");
                      }
                    }
                  }}
                  required
                />
              </div>
              <div>
                <FormInputs
                  label="DPP Window End"
                  style={{ width: "100%" }}
                  value={testEndDate || ""}
                  isRequired={false}
                  disable={false}
                  type="datetime-local"
                  min={
                    testStartDate
                      ? getMinEndDateTime(testStartDate)
                      : getCurrentDateTime()
                  }
                  onChange={(e) => {
                    const newEndDate = e.target.value;
                    setTestEndDate(newEndDate);
                  }}
                  required
                />
              </div>
            </div>
          </div>
          <div style={{ padding: "0px 60px 20px 20px" }}>
            <TextEditor
              templates={testTemplates}
              value={instructionsHtml}
              setValue={setInstructionsHtml}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DPPSchedulingNotification;
